import script from "./ConfirmAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmAddress.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmAddress.vue?vue&type=style&index=0&id=1145ef4b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1145ef4b"]])

export default __exports__